import React from 'react'
import HospitalRequests from '../../components/HospitalRequests/HospitalRequests'

function AdminHospitalRequestPage() {
  return (
    <HospitalRequests/>
  )
}

export default AdminHospitalRequestPage